export default __webpack_public_path__ + "static/media/footer1.72f503f5.png";